import styled from 'styled-components';
import { BlueColors, NeutralColors } from 'theme';

const ToastWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const ToastIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${BlueColors[60]};
  }
`;

const ToastBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

const ToastTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${NeutralColors[100]};
  margin: 0;
`;

const ToastDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${NeutralColors[80]};
  margin: 0;
  white-space: pre-line;
`;

const ToastActions = styled.div`
  display: flex;
  align-items: end;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
`;

export {
  ToastActions,
  ToastBody,
  ToastDescription,
  ToastIconWrapper,
  ToastTitle,
  ToastWrapper,
};
